import { CustomFormTemplate, FpCompany, User } from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
}

interface ResponseDataType extends CustomFormTemplate {
  max_page_count: number;
  company: FpCompany;
  user: User;
}

export const getCustomFormTemplateDraftInitialDataRequest = ({ token }: RequestParams): Promise<ResponseDataType> => {
  return ApiServiceInstance.makeRequest(`/custom-form-template/draft-initial-data`, {
    token,
  });
};